import { render, staticRenderFns } from "./buscarCaja.vue?vue&type=template&id=2b48d356"
import script from "./buscarCaja.vue?vue&type=script&lang=js"
export * from "./buscarCaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports